import { useMeetingBrandingStore } from '@/features/meeting/store/meeting-branding.store'

export function useBranding() {
  const logos = useMeetingBrandingStore((s) => s.logos)
  const setLogos = useMeetingBrandingStore((s) => s.setLogos)
  const addLogo = useMeetingBrandingStore((s) => s.addLogo)
  const removeLogo = useMeetingBrandingStore((s) => s.removeLogo)

  const backgrounds = useMeetingBrandingStore((s) => s.backgrounds)
  const setBackgrounds = useMeetingBrandingStore((s) => s.setBackgrounds)
  const addBackground = useMeetingBrandingStore((s) => s.addBackground)
  const removeBackground = useMeetingBrandingStore((s) => s.removeBackground)

  const overlays = useMeetingBrandingStore((s) => s.overlays)
  const setOverlays = useMeetingBrandingStore((s) => s.setOverlays)
  const toggleOverlay = useMeetingBrandingStore((s) => s.toggleOverlay)

  const videoClips = useMeetingBrandingStore((s) => s.videoClips)
  const setVideoClips = useMeetingBrandingStore((s) => s.setVideoClips)
  const addVideoClip = useMeetingBrandingStore((s) => s.addVideoClip)
  const removeVideoClip = useMeetingBrandingStore((s) => s.removeVideoClip)

  const audioClips = useMeetingBrandingStore((s) => s.audioClips)
  const setAudioClips = useMeetingBrandingStore((s) => s.setAudioClips)
  const addAudioClip = useMeetingBrandingStore((s) => s.addAudioClip)
  const removeAudioClip = useMeetingBrandingStore((s) => s.removeAudioClip)

  return {
    logos,
    setLogos,
    addLogo,
    removeLogo,
    backgrounds,
    setBackgrounds,
    addBackground,
    removeBackground,
    overlays,
    setOverlays,
    toggleOverlay,
    videoClips,
    setVideoClips,
    addVideoClip,
    removeVideoClip,
    audioClips,
    setAudioClips,
    addAudioClip,
    removeAudioClip,
  }
}
